import useToastStore from '@/stores/useToastStore/useToastStore'
import { useTranslation } from 'react-i18next'
import { useExportTotalEmissionsReport } from '../../hooks/useExportTotalEmissionsReport'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'

export type ExportTotalEmissionsReportProps = {
    reportId: string
    onClick?: () => void
}

export const ExportTotalEmissionsReport: React.FC<
    ExportTotalEmissionsReportProps
> = ({ reportId, onClick }) => {
    const addAlert = useToastStore((state) => state.addAlert)
    const { t } = useTranslation('translations')

    const { exportTotalEmissionsReport } =
        useExportTotalEmissionsReport(reportId)

    return (
        <MenuItem
            path="/"
            variant="ghost"
            label={t('common.export_report_dropdown.options.xls')}
            render={({ renderContents }) => (
                <button
                    className="group w-full outline-none"
                    onClick={() => {
                        addAlert({
                            variant: 'success',
                            title: t(
                                'reporting.export_report.success_toast.title'
                            ),
                            description: t(
                                'reporting.export_report.success_toast.description'
                            ),
                        })
                        onClick?.()
                        exportTotalEmissionsReport()
                    }}
                    data-testid="export-total-emissions-excel-button"
                >
                    {renderContents()}
                </button>
            )}
        />
    )
}
